import { render, staticRenderFns } from "./RegisterStudents.vue?vue&type=template&id=1467e678"
import script from "./RegisterStudents.vue?vue&type=script&lang=js"
export * from "./RegisterStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports